// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"3d421093","259":"5bd63b92","281":"f9f7cd28","453":"be517f85","498":"4e77ed3b","526":"b8b1c67a","744":"176bbc45"}[chunkId] + ".chunk.js";
};